<template>
    <div class="sarticle">
        <div>
            <b>
                Félicitation  : vous êtes inscrit à ce concours !
            </b>
        </div>
        Le concours n'a pas encore démarré...<br/><br/>
        Il devrait démarrer le {{formatDate(tournoi.date)}}<br/>
        Il y a {{tournoi.joueurs.length}} joueurs inscrits<br/><br/>

        Vous avez le numéro <b>{{numeroJoueur+1}}</b> <br/>
        <i>ATTENTION : Tant que le concours n'a pas démarré, le numéro est temporaire !<br/></i>
        
    </div>
</template>
<style scoped>
    .sarticle {
        font-size: 20px;
        padding: 20px;
        color: black;
    }
</style>
<script>
export default {
    props: ["joueur", "club", "tournoi","numeroJoueur"],
    methods: {
        formatDate(timestamp) {
            var dateCurrent = new Date(timestamp);
            var options = {weekday: "numeric", year: "numeric", month: "numeric", day: "numeric"};

            return dateCurrent.toLocaleDateString('fr-FR') + " à " + 
                this.tournoi.heure
        },
    }
}
</script>